import React from "react";
import moment from "moment";
import { retailerLogos } from "./retailerLogos";
import { isNotVisited, isPlaned, isVisited } from "../planning/Calendar.utils";
const getCardColor = event => {
  if (isVisited(event)) {
    if (isPlaned(event)) return "#998fc2";
    return "#5596c4";
  }
  if (isNotVisited(event)) return "#dd3e33";
  return "#66b957";
};
export const CardEventMap = ({ event, hoveredPdcId, setHoveredPdcId }) => {
  const retailerId = event.retailer_id;

  const cardStyle =
    hoveredPdcId === event.pdc_id
      ? { borderColor: "#ec841d", backgroundColor: "#fff1e3", borderWidth: 5 }
      : { borderColor: getCardColor(event), borderWidth: 5 };
  return (
    <div
      key={event._id}
      className="p-calendar-map-pdcs-item"
      style={cardStyle}
      onMouseEnter={() => setHoveredPdcId(event.pdc_id)}
      onMouseLeave={() => setHoveredPdcId(null)}
    >
      <div className="p-calendar-map-pdcs-item-date">
        {moment(event.start_date).format("HH:mm")} - {moment(event.end_date).format("HH:mm")}
      </div>
      <div className="p-calendar-map-pdcs-item-name">
        {retailerLogos[retailerId] ? (
          <img className="p-mrg-right-s" height={20} width={20} src={`/img/retailer/${retailerLogos[retailerId]}`} />
        ) : null}
        {event.pdc_label}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// src/containers/activite/map/CardMap.js